import React from 'react';

import { Divider as MuiDivider, Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    height: props.height || 2,
    backgroundColor: '#E9E9E9',
  }),
}));

export default function Divider({ width, ...props }) {
  const classes = useStyles(props);

  return (
    <Box width={width} {...props}>
      <MuiDivider
        classes={{
          root: classes.root,
        }}
      />
    </Box>
  );
}
